<template>
  <div class="crewHome">
    <div class="crewHome-content">
      <div class="companyDetail-title">企业信息</div>
      <el-form
        class="companyDetail-form"
        label-position="right"
        label-width="180px"
        :model="formLabelAlign"
      >
        <el-form-item label="企业名称:">
          <el-input
            v-model="formLabelAlign.companyName"
            placeholder="请填写企业名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="法人代表:">
          <el-input
            v-model="formLabelAlign.legalPerson"
            placeholder="请填写法人代表"
          ></el-input>
        </el-form-item>
        <el-form-item label="社会统一信用代码:">
          <el-input
            v-model="formLabelAlign.organizationCode"
            placeholder="请填写社会统一信用代码"
          ></el-input>
        </el-form-item>
        <el-form-item label="企业logo:">
          <el-upload
            class="avatar-uploader3"
            action
            :http-request="uploadFile"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
            :on-success="handleAvatarSuccess"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar3" />
            <i
              v-else
              class="el-icon-plus avatar-uploader-icon other-avatar-icon3"
            ></i>
          </el-upload>
          <div class="compangDetail-png">
            请上传不小于100*100像素的图片，支持jpg、png格式，大小不能超过200KB
          </div>
        </el-form-item>
        <el-form-item label="营业执照:">
          <el-upload
            class="avatar-uploader2"
            action
            :http-request="uploadFile2"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
            :on-success="handleAvatarSuccess2"
          >
            <img
              v-if="imageUrl2"
              :src="imageUrl2"
              class="avatar other-avatar"
            />
            <i
              v-else
              class="el-icon-plus avatar-uploader-icon other-avatar-icon"
            ></i>
          </el-upload>
          <div class="compangDetail-png">
            请上传5:3(如：250*150)的图片，支持jpg、png格式，大小不能超过200KB
          </div>
        </el-form-item>
        <el-form-item label="手持营业执照:">
          <el-upload
            class="avatar-uploader2"
            action
            :http-request="uploadFile3"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
            :on-success="handleAvatarSuccess3"
          >
            <img
              v-if="imageUrl3"
              :src="imageUrl3"
              class="avatar other-avatar"
            />
            <i
              v-else
              class="el-icon-plus avatar-uploader-icon other-avatar-icon"
            ></i>
          </el-upload>
          <div class="compangDetail-png">
            请上传5:3(如：250*150)的图片，支持jpg、png格式，大小不能超过200KB
          </div>
        </el-form-item>
        <el-form-item label="企业地址:">
          <el-select
            v-model="value1"
            filterable
            clearable
            @change="changePro(value1)"
            placeholder="请选择省"
            style="margin-right: 10px"
          >
            <el-option
              v-for="item in options"
              :key="item.code"
              :value="item.itemNameCn"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="value2"
            filterable
            clearable
            @change="changeCity(value2)"
            placeholder="请选择市/区"
            style="margin-right: 10px"
          >
            <el-option
              v-for="item in options2"
              :key="item.code"
              :value="item.itemNameCn"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="value3"
            filterable
            clearable
            @change="changeArea(value3)"
            placeholder="请选择区/县"
          >
            <el-option
              v-for="item in options3"
              :key="item.code"
              :value="item.itemNameCn"
            >
            </el-option>
          </el-select>
          <div style="margin-top: 10px">
            <el-input
              placeholder="请填写企业详细地址"
              v-model="formLabelAlign.address"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item label="企业简介:">
          <el-input
            type="textarea"
            rows="4"
            placeholder="请填写企业简介"
            resize="none"
            v-model="formLabelAlign.companyInfo"
          ></el-input>
        </el-form-item>
        <el-form-item label="招聘联系人:">
          <el-input
            type="text"
            placeholder="请填写招聘联系人"
            v-model="formLabelAlign.recruitConcatName"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话:">
          <el-input
            type="text"
            placeholder="请填写联系电话"
            v-model="formLabelAlign.recruitConcatPhone"
          ></el-input>
        </el-form-item>
        <div class="save-companyDetail" @click="saveBaseList()">保存</div>
      </el-form>
    </div>
  </div>
</template>
<script>
import {
  getProvinceList,
  getCityList,
  getAreaList,
  updateBaseInfo,
  getBaseInfo,
  getOneFile,
} from "@/apis/index";
import { post } from "@/apis/axios";
import { apiRoot } from "@/config";
export default {
  data() {
    return {
      formLabelAlign: {},
      imageUrl: "",
      imageUrl2: "",
      imageUrl3: "",
      value1: "",
      value2: "",
      value3: "",
      options: [],
      options2: [],
      options3: [],
      proCode: "",
      cityCode: "",
      areaCode: "",
    };
  },
  mounted() {
    this.getProvinceLists();
    this.getBaseInfoList();
  },
  methods: {
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    handleAvatarSuccess2(res, file) {
      this.imageUrl2 = URL.createObjectURL(file.raw);
    },
    handleAvatarSuccess3(res, file) {
      this.imageUrl3 = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPng = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG && !isPng) {
        this.$message.error("上传头像图片只能是 JPG 或者 PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return (isJPG || isPng) && isLt2M;
    },
    //照片
    uploadFile(file) {
      this.loading = true;
      this.imageUrl = URL.createObjectURL(file.file);
      let fileData = new FormData();
      fileData.delete("uploadFiles");
      fileData.append("uploadFiles", file.file);
      post(`${apiRoot}/file/singleFileUpload`, fileData, { upload: true })
        .then((res) => {
          this.formLabelAlign.logo = res.data;
        })
        .catch(() => {});
    },
    uploadFile2(file) {
      this.loading = true;
      this.imageUrl2 = URL.createObjectURL(file.file);
      let fileData = new FormData();
      fileData.delete("uploadFiles");
      fileData.append("uploadFiles", file.file);
      post(`${apiRoot}/file/singleFileUpload`, fileData, { upload: true })
        .then((res) => {
          this.formLabelAlign.businessLicense = res.data;
        })
        .catch(() => {});
    },
    uploadFile3(file) {
      this.loading = true;
      this.imageUrl3 = URL.createObjectURL(file.file);
      let fileData = new FormData();
      fileData.delete("uploadFiles");
      fileData.append("uploadFiles", file.file);
      post(`${apiRoot}/file/singleFileUpload`, fileData, { upload: true })
        .then((res) => {
          // console.log(res);
          this.formLabelAlign.businessLicenseHold = res.data;
        })
        .catch(() => {});
    },
    //省
    async getProvinceLists() {
      const res = await getProvinceList();
      // this.trainList = res.data.resultList;
      // console.log(res);
      this.options = res.data;
    },
    async getBaseInfoList() {
      let companyId = sessionStorage.getItem("companyId");
      const res = await getBaseInfo({ companyId: companyId });
      this.formLabelAlign = res.data;
      this.value1 = res.data.provinceName;
      this.value2 = res.data.cityName;
      this.value3 = res.data.areaName;
      this.options.forEach((item) => {
        if (item.itemNameCn == this.value1) {
          this.proCode = item.code;
        }
      });
      this.getCityLists();
      let that = this;
      setTimeout(() => {
        that.options2.forEach((item) => {
          if (item.itemNameCn == that.value2) {
            that.cityCode = item.code;
          }
        });
        that.getAreaLists();
      }, 1000);
      this.lookFileSrc(res.data.logo, 1);

      this.lookFileSrc(res.data.businessLicense, 2);
      this.lookFileSrc(res.data.businessLicenseHold, 3);
    },
    async lookFileSrc(src, type) {
      // console.log(src);
      let url = await getOneFile({
        fileName: src[0] == "/" ? "file" + src : "file/" + src,
      });
      if (type == 1) {
        this.imageUrl = url.data;
      } else if (type == 2) {
        this.imageUrl2 = url.data;
      } else if (type == 3) {
        this.imageUrl3 = url.data;
      }
    },
    changePro(e) {
      this.value2 = "";
      this.value3 = "";
      this.options3 = [];
      this.options.forEach((item) => {
        if (item.itemNameCn == e) {
          this.proCode = item.code;
          this.formLabelAlign.province = item.code;
        }
      });
      this.getCityLists();
    },
    changeCity(e) {
      this.value3 = "";
      this.options2.forEach((item) => {
        if (item.itemNameCn == e) {
          this.cityCode = item.code;
          this.formLabelAlign.city = item.code;
        }
      });
      this.getAreaLists();
    },
    changeArea(e) {
      this.options3.forEach((item) => {
        if (item.itemNameCn == e) {
          this.areaCode = item.code;
          this.formLabelAlign.area = item.code;
        }
      });
    },
    //城市
    async getCityLists() {
      const res = await getCityList({ code: this.proCode });
      // this.trainList = res.data.resultList;
      // console.log(res);
      this.options2 = res.data;
    },
    //区
    async getAreaLists() {
      const res = await getAreaList({ code: this.cityCode });
      // this.trainList = res.data.resultList;
      // console.log(res);
      this.options3 = res.data;
    },
    async saveBaseList() {
      let companyId = sessionStorage.getItem("companyId");
      let userId = sessionStorage.getItem("userId");
      const res = await updateBaseInfo({
        companyId: companyId,
        userId: userId,
        province: this.proCode,
        city: this.cityCode,
        area: this.areaCode,
        ...this.formLabelAlign,
      });
      if (res.code == 1) {
        this.$message({
          message: "保存成功",
          type: "success",
        });
      } else {
        this.$message({
          message: "保存失败",
          type: "error",
        });
      }
      // this.trainList = res.data.resultList;
      // console.log(res);
    },
  },
};
</script>
<style lang="scss" scoped></style>
